import uuid from 'react-native-uuid';
import firebase from '../firebase/Config';

class TrackFile {
    constructor(file, projectId, artistId) {
        this.trackId = uuid.v4();
        this.revId = uuid.v4();
        this.data = file;
        this.name = file.name;
        this.size = file.size;
        this.lastModified = file.lastModified;
        this.projectId = projectId;
        this.artistId = artistId;
        this.uploadingProgress = 0;
    }

    // Generates the track metadata for uploading
    getTrackMetadata() {
        return this.getDuration().then((duration) => {
            var data = {
                artistId: this.artistId,
                projectId: this.projectId,
                lastModified: this.lastModified,
                revId: this.revId,
                name: this.name,
                duration: duration,
                size: this.size,
                uId: firebase.auth().currentUser.uid,
            }
            const getMetadata = firebase.functions().httpsCallable("getTrackMetadata");
            return getMetadata(data);
        }).then((result) => {
            return result.data.data;
        })
    }

    getDuration() {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async function(event) {
              try {
                const data = event.target.result;
                const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                const audioBuffer = await audioCtx.decodeAudioData(data);
                resolve(audioBuffer.duration);
              } catch (err) {
                reject(err);
              }
            };
            reader.readAsArrayBuffer(this.data);
          });
    }

    upload(progressDidUpdate) {
        const storageRef = firebase.storage().ref("audio").child(this.revId);
        const uploadToken = firebase.functions().httpsCallable("uploadToken");
        const currUserId = firebase.auth().currentUser.uid;
        uploadToken({ "uId": currUserId, "path": this.data }).then((result) => {
            return result.data.token;
        }).then((token) => {
            return firebase.auth().signInWithCustomToken(token);
        }).then((_) => {
            const uploadTask = storageRef.put(this.data);
            uploadTask.on('state_changed', (snapshot) => {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes);
                progressDidUpdate(progress);
            });
            return uploadTask;
        }).then(() => {
            return storageRef.getDownloadURL();
        }).then((downloadURL)=> {
            return Promise.all([Promise.resolve(downloadURL), this.getTrackMetadata()]);
        }).then(response => {
            var downloadURL = response[0];
            var metadata = response[1];
            metadata["revisions"][this.revId]["metadata"]["remote url"] = downloadURL; // Set the storage URL
            progressDidUpdate(200); // Special code to indicate finished upload
            return firebase.database().ref("artists").child(this.artistId).child("projects").child(this.projectId).child("tracks").child(this.trackId).set(metadata);
        }).catch((err) => {
            alert("Please upgrade your storage plan from the Demodeck app.")
            console.error(err);
        });
    }
}

export default TrackFile;